import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.083 9.166h-6.25v-6.25L13.37 5.45l2.708-2.708 1.179 1.178-2.708 2.709zM2.917 10.832h6.25v6.25L6.63 14.546l-2.708 2.709-1.179-1.179 2.708-2.708z"
    }, null, -1)
  ])))
}
export default { render: render }